/* eslint-disable */
/// This file is auto generated - do not edit manually
export const OpenDetailsButtonText = 'Website.MatasPlus.OfferNudge.OpenDetailsButtonText';
export const AddToBasketError = 'Website.MatasPlus.OfferNudge.AddToBasketError';
export const AddToBasketSuccess = 'Website.MatasPlus.OfferNudge.AddToBasketSuccess';
export const SignUpHeading = 'Website.MatasPlus.OfferNudge.SignUpHeading';
export const SignUpBodyText = 'Website.MatasPlus.OfferNudge.SignUpBodyText';
export const AddedToBasketHeading = 'Website.MatasPlus.OfferNudge.AddedToBasketHeading';
export const AddedToBasketBodyText = 'Website.MatasPlus.OfferNudge.AddedToBasketBodyText';
export const ShopNowButtonText = 'Website.MatasPlus.OfferNudge.ShopNowButtonText';
export const ActivatePlusButtonText = 'Website.MatasPlus.OfferNudge.ActivatePlusButtonText';
